module.exports = __webpack_public_path__ + "img/img-7.4dbb8c9d.jpg";